import React from "react";

import classNames from "classnames";
import brand from "@utils/brand";
import { Text, CbWrapper } from "@atoms";

const CbBlockQuote = ({ quote, citation, indent, type }) => {
  const { romero } = brand;
  return (
    <CbWrapper type={type} indent={indent}>
      <div className="max-w-lg md:-ml-6 lg:-ml-12 lg:pt-4 lg:pb-2">
        <Text
          variant="blockquote"
          className={classNames("mb-3", {
            "font-serif font-bold": !romero,
          })}
        >
          {quote}
        </Text>
        {citation && (
          <Text
            variant={romero ? "body" : "body--large-tight"}
            className={classNames("citation mt-4", {
              "font-bold uppercase tracking-widest": romero,
            })}
          >
            {citation}
          </Text>
        )}
      </div>
    </CbWrapper>
  );
};

CbBlockQuote.defaultProps = {};

export default CbBlockQuote;
